module.exports = __webpack_public_path__ + "static/Champ-993fc9022cefa2f094c90ec17a0c44f7.png";